import type { User } from '../types';

import { Icon, type IconName } from './Icon';

export type Section =
  | 'mail'
  | 'calendar'
  | 'contacts'
  | 'migration'
  | 'admin'
  | 'billing'
  | 'settings';

interface Props {
  user: User;
  active: Section;
  onSelect: (s: Section) => void;
  onLogout: () => void;
}

interface Item {
  id: Section;
  icon: IconName;
  label: string;
  adminOnly?: boolean;
  soon?: boolean;
}

/**
 * Rol keçidi (docs/05-panel-ui.md).
 *
 * Şirkət admini poçtdan idarəyə EYNİ sessiya ilə keçir — Google
 * Workspace-in ayrı `admin.google.com` saytına atmasından fərqli olaraq.
 * Kiçik şirkətdə "admin" ayrıca adam deyil, elə direktordur.
 */
const ITEMS: Item[] = [
  { id: 'mail', icon: 'inbox', label: 'Poçt' },
  { id: 'calendar', icon: 'calendar', label: 'Kalendar', soon: true },
  { id: 'contacts', icon: 'contacts', label: 'Kontaktlar', soon: true },
  // Köçürmə bir dəfəlik əməliyyatdır, amma YENİ MÜŞTƏRİ ÜÇÜN ƏN VACİB
  // addımdır — köhnə poçtunu gətirə bilməyən müştəri xidmətdən imtina edir.
  // Ayarların içinə gizlətsək, tapılmayacaq.
  { id: 'migration', icon: 'import', label: 'Köhnə poçtu köçür' },
  { id: 'admin', icon: 'building', label: 'Şirkət idarəsi', adminOnly: true },
  // ⚠️ `soon` GÖTÜRÜLDÜ. Abunə ekranı artıq işləyir: sınaq sayğacı,
  // qiymət hesablaması, faktura rekvizitləri. Söndürülmüş düymə qalsaydı,
  // sınağı bitən müştəri ödəməyin YOLUNU TAPA BİLMƏZDİ — yəni gəlir
  // yolunun qapısı bağlı qalardı.
  { id: 'billing', icon: 'billing', label: 'Abunə', adminOnly: true },
  { id: 'settings', icon: 'settings', label: 'Ayarlar' },
];

export function AppRail({ user, active, onSelect, onLogout }: Props): React.ReactElement {
  const items = ITEMS.filter((i) => !i.adminOnly || user.isTenantAdmin);

  return (
    <aside className="rail">
      <div className="rail-mark" title="Mailora">
        M
      </div>

      <nav className="rail-nav" aria-label="Bölmələr">
        {items.map((i) => (
          <button
            key={i.id}
            className={`rail-btn ${i.id === active ? 'is-active' : ''}`}
            onClick={() => onSelect(i.id)}
            title={i.soon ? `${i.label} — tezliklə` : i.label}
            aria-label={i.label}
            disabled={i.soon}
          >
            <span aria-hidden="true"><Icon name={i.icon} size={20} /></span>
          </button>
        ))}
      </nav>

      <div className="rail-foot">
        <button
          className="rail-avatar"
          onClick={onLogout}
          title={`${user.email} — çıxış`}
          aria-label="Çıxış"
        >
          {user.email.slice(0, 1).toUpperCase()}
        </button>
      </div>
    </aside>
  );
}
